import React from 'react';

export default function BrandedLoader({ message = "Loading, please wait…" }) {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#fff'
    }}>
      <div style={{
        border: '8px solid #f3f3f3',
        borderTop: '8px solid #ff4713',
        borderRadius: '50%',
        width: 64,
        height: 64,
        animation: 'spin 1s linear infinite'
      }} />
      <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      <h2 style={{
        color: '#0a0e3f',
        marginTop: 32,
        fontWeight: 700,
        fontFamily: 'monospace'
      }}>orrekie</h2>
      <p style={{
        color: '#333',
        marginTop: 8,
        fontSize: 18
      }}>{message}</p>
    </div>
  );
}
